<template>
    <InputText
        type="number"
        :modelValue="value"
        @blur="$emit('handleValueChange', parseInt($event.target.value))"
        @wheel="$event.target.blur()"
        placeholder="Enter integer"
    />
</template>

<script>
export default {
    name: 'IntRule',
    props: ['value'],
};
</script>

<style scoped></style>
